import { useState, useEffect } from 'react';
import { FaCoins } from 'react-icons/fa';

/**
 * Componente de animação que mostra quantos pontos foram ganhos após finalizar compra
 * Similar ao CartAddAnimation, mas para pontos
 * 
 * @param {number} pontos - Quantidade de pontos ganhos
 * @param {boolean} show - Se deve mostrar a animação
 * @param {string} className - Classes CSS adicionais
 */
export default function PontosEarnedAnimation({ pontos = 0, show = false, className = "" }) {
  const [isVisible, setIsVisible] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (show && pontos > 0) {
      setIsVisible(true);
      setKey(prev => prev + 1); // Força re-render para nova animação
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 2500); // Animação desaparece após 2.5s (um pouco mais que o carrinho)

      return () => clearTimeout(timer);
    }
  }, [show, pontos]);

  if (!isVisible) return null;

  return (
    <div 
      key={key}
      className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none z-[9999] ${className}`}
      style={{
        animation: 'pontosEarnedPulse 1s cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
      }}
    >
      <div className="flex flex-col items-center justify-center">
        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full p-6 shadow-2xl mb-4">
          <FaCoins className="text-white text-4xl" />
        </div>
        <div className="flex flex-col items-center">
          <span 
            className="text-4xl font-black text-yellow-400 drop-shadow-lg"
            style={{
              textShadow: '0 2px 16px rgba(234, 179, 8, 0.8), 0 0 32px rgba(234, 179, 8, 0.6)',
              animation: 'pontosEarnedFade 2.5s ease-out forwards',
            }}
          >
            +{pontos} pts
          </span>
          <span 
            className="text-xl font-bold text-white mt-2"
            style={{
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.5)',
              animation: 'pontosEarnedFade 2.5s ease-out forwards',
            }}
          >
            Pontos ganhos!
          </span>
        </div>
      </div>
      <style>{`
        @keyframes pontosEarnedPulse {
          0% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.3) translateY(30px);
          }
          20% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1.2) translateY(-20px);
          }
          40% {
            transform: translate(-50%, -50%) scale(1.1) translateY(-30px);
          }
          60% {
            transform: translate(-50%, -50%) scale(1.05) translateY(-35px);
          }
          100% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.95) translateY(-60px);
          }
        }
        @keyframes pontosEarnedFade {
          0%, 50% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}




